"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _modalActions = require("../actions/modalActions");

var _interactionsActions = require("../actions/interactionsActions");

var _interactions = require("../constants/interactions");

var _fromJS, _handleActions;

var initialState = (0, _immutable.fromJS)((_fromJS = {}, (0, _defineProperty2.default)(_fromJS, _interactions.STYLESHEET_SELECT_MODAL_OPEN, false), (0, _defineProperty2.default)(_fromJS, _interactions.CONTACT_PROPERTY_DEFAULTS_MODAL_OPEN, false), (0, _defineProperty2.default)(_fromJS, _interactions.COMPANY_PROPERTY_DEFAULTS_MODAL_OPEN, false), (0, _defineProperty2.default)(_fromJS, _interactions.OWNER_PROPERTY_DEFAULTS_MODAL_OPEN, false), (0, _defineProperty2.default)(_fromJS, _interactions.PROPERTY_SEARCH, ''), (0, _defineProperty2.default)(_fromJS, _interactions.SELECTED_PROPERTY, null), _fromJS));

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_STYLESHEET_SELECT_MODAL, function (state) {
  return state.set(_interactions.STYLESHEET_SELECT_MODAL_OPEN, true);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_CONTACT_PROPERTY_DEFAULTS_MODAL, function (state) {
  return state.set(_interactions.CONTACT_PROPERTY_DEFAULTS_MODAL_OPEN, true);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_COMPANY_PROPERTY_DEFAULTS_MODAL, function (state) {
  return state.set(_interactions.COMPANY_PROPERTY_DEFAULTS_MODAL_OPEN, true);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_OWNER_PROPERTY_DEFAULTS_MODAL, function (state) {
  return state.set(_interactions.OWNER_PROPERTY_DEFAULTS_MODAL_OPEN, true);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.CLOSE_MODAL, function (state) {
  var _state$merge;

  return state.merge((_state$merge = {}, (0, _defineProperty2.default)(_state$merge, _interactions.STYLESHEET_SELECT_MODAL_OPEN, false), (0, _defineProperty2.default)(_state$merge, _interactions.CONTACT_PROPERTY_DEFAULTS_MODAL_OPEN, false), (0, _defineProperty2.default)(_state$merge, _interactions.COMPANY_PROPERTY_DEFAULTS_MODAL_OPEN, false), (0, _defineProperty2.default)(_state$merge, _interactions.OWNER_PROPERTY_DEFAULTS_MODAL_OPEN, false), _state$merge));
}), (0, _defineProperty2.default)(_handleActions, _interactionsActions.InteractionsActionTypes.CHANGE_PROPERTY_SEARCH, function (state, action) {
  return state.set(_interactions.PROPERTY_SEARCH, action.payload[_interactions.PROPERTY_SEARCH]);
}), (0, _defineProperty2.default)(_handleActions, _interactionsActions.InteractionsActionTypes.CHANGE_SELECTED_PROPERTY, function (state, action) {
  return state.set(_interactions.SELECTED_PROPERTY, action.payload[_interactions.SELECTED_PROPERTY]);
}), (0, _defineProperty2.default)(_handleActions, _interactionsActions.InteractionsActionTypes.CANCEL_CHANGE_PROPERTIES, function (state) {
  var _state$merge2;

  return state.merge((_state$merge2 = {}, (0, _defineProperty2.default)(_state$merge2, _interactions.PROPERTY_SEARCH, ''), (0, _defineProperty2.default)(_state$merge2, _interactions.SELECTED_PROPERTY, null), _state$merge2));
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;